import React from "react";

import CircularProgress from "@mui/material/CircularProgress";

import { Box } from "@mui/material";

export default function Loading({ specificDetails }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        ...(specificDetails?.style ?? {}),
      }}
    >
      <CircularProgress size={specificDetails?.size} />
    </Box>
  );
}
